import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { LocationCodeProvider } from './shared/contexts/LocationCodeContext';
import { AppRoutes } from './app/router';

function useSessionExpiredRedirect() {
  const navigate = useNavigate();

  const handler = useCallback(() => {
    navigate('/signin', { replace: true });
  }, [navigate]);

  useEffect(() => {
    window.addEventListener('auth:session-expired', handler);
    return () => window.removeEventListener('auth:session-expired', handler);
  }, [handler]);
}

export default function App() {
  useSessionExpiredRedirect();

  return (
    <LocationCodeProvider>
      <AppRoutes />
    </LocationCodeProvider>
  );
}
